import type { MarkerSectorProps } from "./marker-sector.type";

import { scaleMarkerSectorSize } from "./marker-sector.helper";

import "./marker-sector.style.less";

const MarkerSector = ({ scale }: MarkerSectorProps) => {
  const { width, height } = scaleMarkerSectorSize(scale);

  return (
    <svg
      viewBox="0 0 27 31"
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      className="marker-sector"
    >
      <path
        fill="#fff"
        d="M13.5,0c-1.8,0-3.6.4-5.3,1.1-1.6.7-3.1,1.7-4.3,2.9-1.2,1.2-2.2,2.7-2.9,4.3-.7,1.7-1.1,3.4-1.1,5.3s.4,3.6,1.1,5.3c.7,1.6,1.7,3.1,2.9,4.3,1.2,1.2,9.5,7.5,9.5,7.5,0,0,8.3-6.3,9.5-7.5,1.2-1.2,2.2-2.7,2.9-4.3.7-1.7,1.1-3.4,1.1-5.3s-.4-3.6-1.1-5.3c-.7-1.6-1.7-3.1-2.9-4.3-1.2-1.2-2.7-2.2-4.3-2.9-1.7-.7-3.4-1.1-5.3-1.1h0Z"
      />
      <path
        fill="#2049ed"
        d="M13.5,2.3C7.2,2.3,2.1,7.3,2.1,13.6s5.1,11.4,11.4,11.4,11.4-5.1,11.4-11.4S19.8,2.3,13.5,2.3ZM13.5,18.9l-5.2-5.2,5.2-5.2,5.2,5.2-5.2,5.2Z"
      />
    </svg>
  );
};

export default MarkerSector;
